import React, { useMemo, useState } from 'react';
import { DropDown } from '../components/commons/DropDown';
import { TargetType } from 'components/features/target-achievement-support/utils/type';
import {
  isTargetType,
  targetTypeToIconImg,
  targetTypeToTitle,
  targetTypes,
} from 'components/features/target-achievement-support/utils/targetInfo';

export const useTargetTypeForm = (
  initialTargetType: TargetType
): {
  TargetTypeForm: React.ReactElement;
  targetType: TargetType;
} => {
  const [targetType, setTargetType] = useState<TargetType>(initialTargetType);
  const targetImage = useMemo(() => targetTypeToIconImg(targetType), [
    targetType,
  ]);
  const states = targetTypes.map(type => type.targetType);
  const toString = (value: number) => `${value.toString()}`;
  const fromString = (
    str: string
  ): { tag: 'Just'; value: TargetType } | { tag: 'Nothing' } => {
    if (!str) return { tag: 'Nothing' };
    const num = Number(str);
    if (!isTargetType(num)) return { tag: 'Nothing' };
    return {
      tag: 'Just',
      value: num,
    };
  };

  const TargetTypeForm = useMemo((): React.ReactElement => {
    return (
      <div className="flex flex-row">
        <img
          src={targetImage}
          alt="目標のイメージ"
          className="w-10 h-10 rounded-full mr-4"
          style={{ objectFit: 'cover' }}
        />
        <DropDown
          {...{
            state: targetType,
            setState: setTargetType,
            dropdownIcon: 'chevron-down',
            fromString,
            states,
            toLabel: targetTypeToTitle,
            toString_: toString,
            classNames: {
              container: prev => `${prev} pl-4`,
              select: prev => `${prev} text-base`,
            },
          }}
          style={{ width: '204px' }}
          key="targetType"
        />
      </div>
    );
  }, [targetImage, targetType, states]);
  return { TargetTypeForm, targetType };
};
